<div id="html-content">
  <edm-back-button class="d-flex position-relative" displayStyle="circular" [backUrl]="backUrl"></edm-back-button>

  @if (!showInIframe) {
    <div  id="html-container" class="hide-scrollbar" [style.display]="loaded ? 'block' : 'none'" [innerHTML]="htmlContent">
    </div>
  }

  @if (showInIframe) {
    <div id="iframe" class="hide-scrollbar" [style.display]="loaded ? 'block' : 'none'" style="padding-top: 0 !important;">
      <iframe [src]="iframeScr" class="hide-scrollbar" [ngClass]="{'h-100vh': this.menuHtml}">
      </iframe>
    </div>
  }

</div>
